import { render, staticRenderFns } from "./SelectCouponDialog.vue?vue&type=template&id=2d90c166&scoped=true"
import script from "./SelectCouponDialog.vue?vue&type=script&lang=js"
export * from "./SelectCouponDialog.vue?vue&type=script&lang=js"
import style0 from "./SelectCouponDialog.vue?vue&type=style&index=0&id=2d90c166&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d90c166",
  null
  
)

export default component.exports